/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ReactivateUserOptions,
  ReactivateUserStatus200,
  ReactivateUserStatus404,
  ReactivateUserStatus409,
  ReactivateUserStatus500,
} from '../types/ReactivateUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { reactivateUser } from '../clients/reactivateUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const reactivateUserMutationKey = () => [{ url: '/v1/user/:user_id/reactivate' }] as const

export function reactivateUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = reactivateUserMutationKey()
  return mutationOptions<
    ReactivateUserStatus200,
    ResponseErrorConfig<
      ReactivateUserStatus404 | ReactivateUserStatus409 | ReactivateUserStatus500
    >,
    ReactivateUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return reactivateUser({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Marks the deactivation REACTIVATED and lifts the trading, funding, and transfer blocks. Only stable requests (COMPLETED or FAILED) can be reactivated; a PENDING wind-down must first complete or fail. The audit trail is preserved.
 * @summary Lift a user's account deactivation (admin)
 * {@link /v1/user/:user_id/reactivate}
 */
export function useReactivateUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ReactivateUserStatus200,
      ResponseErrorConfig<
        ReactivateUserStatus404 | ReactivateUserStatus409 | ReactivateUserStatus500
      >,
      ReactivateUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? reactivateUserMutationKey()

  const baseOptions = reactivateUserMutationOptions(config) as UseMutationOptions<
    ReactivateUserStatus200,
    ResponseErrorConfig<
      ReactivateUserStatus404 | ReactivateUserStatus409 | ReactivateUserStatus500
    >,
    ReactivateUserOptions,
    TContext
  >

  return useMutation<
    ReactivateUserStatus200,
    ResponseErrorConfig<
      ReactivateUserStatus404 | ReactivateUserStatus409 | ReactivateUserStatus500
    >,
    ReactivateUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ReactivateUserStatus200,
    ResponseErrorConfig<
      ReactivateUserStatus404 | ReactivateUserStatus409 | ReactivateUserStatus500
    >,
    ReactivateUserOptions,
    TContext
  >
}
